module.exports = __webpack_public_path__ + "img/cnbc_dark.fe6455c.png";